module.exports = __webpack_public_path__ + "img/ic-chart-bar.82c99913.svg";